import { useTheme } from "@emotion/react";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopyOutlined } from "@mui/icons-material";
import copyTexto from "../../../../utils/copyTexto";
import useStyles from "./styles";

// Botão de copiar do painel de atendimento.
//
// A cópia em si fica no util compartilhado `copyTexto`, que trata o fallback
// para contexto não seguro e avisa pelo snackbar — o mesmo comportamento do
// CopyTexto de `components/sevices/accordionHubsoft`, para que copiar tenha a
// mesma resposta em todo o sistema.
//
// `value` pode ser uma string ou uma função que devolve a string, para o caso
// de montar o texto só no clique.
export default function CopyButton({
  value,
  setSnackbar,
  title = "Clique para copiar",
  mensagem = "Campo copiado!",
  size = "small",
  sx = {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const copiar = async (event) => {
    event.stopPropagation();
    const campo = typeof value === "function" ? value() : value;
    await copyTexto({ campo, setSnackbar, mensagem });
  };

  return (
    <Tooltip title={title}>
      <IconButton size={size} onClick={copiar} sx={{ ...styles.botao, ...sx }}>
        <ContentCopyOutlined sx={styles.icone} />
      </IconButton>
    </Tooltip>
  );
}
